// reducers/connect/offline.js

export function connectOfflineHasErrored(state = false, action) {
  switch (action.type) {
    case 'CONNECT_OFFLINE_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function connectOfflineIsLoading(state = false, action) {
  switch (action.type) {
    case 'CONNECT_OFFLINE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function connectOffline(state = {}, action) {
  switch(action.type) {
    case 'CONNECT_OFFLINE_FETCH_DATA_SUCCESS':
      return action.obj;
    default:
      return state;
  }
}